import React from 'react';
import { Page, Text, View, Document, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  section: {
    marginBottom: 7,
    //border: '1px solid #222',
  },
  sectionCol: {
    flexDirection: 'column',
  },
  headerSection: {
    flexDirection: "row",
    justifyContent: 'space-between',
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: 'space-between',
  },
  flexRowContent: {
    flexDirection: "row",
    justifyContent: 'space-between',
  },
  leftSection: {
    width: '47.5%',
  },
  rightSection: {
    marginLeft: '5%',
    width: '47.5%',
  },
  dateSection: {
    flexDirection: 'row',
    gap: 10,
  },
  pageHeading: {
    fontSize: 18,
    textAlign: 'center',
    position: 'absolute',
    left: 0,
    right: 0,
  },
  fieldContainer: {
    flexDirection: 'row',
  },
  fieldLabel: {
    width: '50%',
    fontSize: 10,
    // fontWeight: 'semibold',
  },
  fieldValue: {
    width: '50%',
    fontSize: 10,
  },
  content: {
    fontSize: 10,
  }
});

const ReceiptPdf = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.pageHeading}>
        <Text>SKA NANKANA SAHIB SOLICITORS</Text>
      </View>
      <View style={styles.headerSection}>
        <View style={styles.logoSection}>
          <Image
            style={{
              width: '60px',
              alignSelf: 'flex-end',
            }}
            src="/logo192.png"
          />
        </View>
        <View style={styles.companySection}>
          <Text style={{ alignSelf: 'flex-end', letterSpacing: 1, fontSize: 20, marginBottom: '5px' }}>Receipt</Text>
          <Text style={{ alignSelf: 'flex-end', fontSize: 8.5, marginBottom: 1 }}>In accordance with the fixed fee</Text>
          <Text style={{ alignSelf: 'flex-end', fontSize: 8.5 }}>agreement and terms of business.</Text>
        </View>
      </View>
      <View style={{ alignContent: 'flex-end', alignItems: 'flex-end', paddingRight: 10, marginTop: 10, marginBottom: 10, maxWidth: '50%', marginLeft: '50%' }}>
        <View style={styles.dateSection}>
          <View style={{ flexDirection: 'column', gap: 14, marginTop: 7 }}>
            <Text style={{ fontSize: 8 }}>Date:</Text>
            <Text style={{ fontSize: 8 }}>Reference Number:</Text>
          </View>
          <View style={{ flexDirection: 'column', gap: 4 }}>
            <Text style={{ border: '1px solid #222', fontSize: 10, padding: 2, width: 100 }}>{data.date}</Text>
            <Text style={{ border: '1px solid #222', fontSize: 10, padding: 2, width: 100 }}>AA/SK/BHAM/{data.fid}</Text>
          </View>
        </View>
      </View>


      <View style={styles.flexRowContent}>
        <View style={styles.leftSection}>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '25%' }}>Client Name:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '80%' }}>{data.client_name}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '25%' }}>Address:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '80%' }}>{data.address}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '25%' }}>Phone:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, width: '80%' }}>{data.phone}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '25%' }}>Mobile:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '80%' }}>{data.mobile}</Text>
            </View>
          </View>
        </View>
      </View>

      <View style={{ marginVertical: 15, }}>
        <Text style={{ fontSize: 9, lineHeight: 1.3, color: '#222' }}>For office use only</Text>
        <Text style={{ fontSize: 9, lineHeight: 1.3, color: '#222' }}>*Please keep a copy in the file and complete internal request for entry now*</Text>
      </View>

      <View style={styles.flexRowContent}>
        <View style={styles.leftSection + { width: '65%' }}>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '19%' }}>Comments:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 100, padding: 2, paddingLeft: 4, width: '81%' }}>{data.comments}</Text>
            </View>
          </View>
        </View>

        <View style={styles.rightSection}>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 0, width: '30%' }}>Payment Method:</Text>
              <Text style={{ fontSize: 11, minHeight: 18, padding: 2, paddingLeft: 4, width: '70%' }}>{data.payment_method}</Text>
            </View>
          </View>
          <View style={styles.fieldContainer}>
            <Text style={{ fontWeight: 700, fontSize: 8, top: 0, width: '30%', wordBreak: 'break-all' }}>Received: </Text>
            <Text style={{ fontSize: 11, minHeight: 18, padding: 2, paddingLeft: 4, width: '70%' }}>{data.payment_received ? "Yes" : "No"}</Text>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 0, width: '30%' }}>Payment Amount:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '70%' }}>{'£' + data.amount}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 0, width: '30%' }}>Balance Due:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '70%' }}>{'£' + data.balance_amount}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 0, width: '30%' }}>Authorized Signature:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 40, padding: 2, paddingLeft: 4, width: '70%' }}></Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6 }}>Note: Fixed costs are agreed and payable
                as a contractual obligation.</Text>
            </View>
          </View>
        </View>
      </View>


      <View style={{ marginTop: 50, marginVertical: 10 }}>
        <Text style={{ textAlign: 'center', fontSize: 10, fontWeight: 'bold' }}>Thank You.</Text>
        <Text style={{ textAlign: 'center', fontSize: 10, fontWeight: 'bold' }}>We appreciate your business.</Text>
      </View>
      <View>
        <Text style={{ textAlign: 'center', fontSize: 13, marginBottom: 5, fontWeight: 'bold' }}>SKA NANKANA SAHIB SOLICITORS</Text>
      </View>
      <View style={{ marginBottom: 5 }}>
        <Text style={{ textAlign: 'center', fontSize: 10 }}>101A Soho Hill, Hockley,</Text>
        <Text style={{ textAlign: 'center', fontSize: 10 }}>Birmingham, B19 1AY</Text>
      </View>
      <View style={{ marginBottom: 15 }}>
        <Text style={{ textAlign: 'center', fontSize: 8 }}>Phone: 0121 493 4730-1</Text>
        <Text style={{ textAlign: 'center', fontSize: 8 }}>Email: office@SKASolicitors.co.uk </Text>
      </View>
      <View>
        <Text style={{ textAlign: 'center', fontSize: 8, fontStyle: 'italic', marginBottom: 3 }}>SKA Nankana Sahib Solicitors is Authorised and Regulated by Solicitors Regulations Authority SRA: 659308</Text>
      </View>
      <View>
        <Text style={{ textAlign: 'center', fontSize: 8, fontStyle: 'italic', marginBottom: 3 }}>and is trading name of Thara Legal Ltd, registered in England and Wales, Companies House No: 11906084,</Text>
      </View>
      <View>
        <Text style={{ textAlign: 'center', fontSize: 8, fontStyle: 'italic' }}>whose registered office is at 144 Desborough Road, High Wycombe, England, United Kingdom</Text>
      </View>
    </Page>
  </Document >
);

export default ReceiptPdf;
